import styles from './ParticipantRequest.css'
import { useState, useEffect } from 'react'
import axiosConfig from '../../../utils/axiosConfig';
import { Button, Divider, Box, List } from '@material-ui/core'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'

import RequestItem from './RequestItem'

const ParticipantRequest = ({classCode, updateParticipant}) => {
    const [participantRequests, setParticipantRequests] = useState([])
    async function getAllParticipantRequests () {
        const response = await axiosConfig.get(`/request-to/joinClass?classcode=${classCode}`);
        setParticipantRequests(response.data.requests)

        if (response.data.requests.length === 0) {
            setShowDialog(false)
        }
    }

    /** Modal Control */
    const [showDialog, setShowDialog] = useState(false)
    const handleClose = () => {
        setShowDialog(false)
    }

    useEffect(() => {
        getAllParticipantRequests()
    }, [])

    return (
        <>
            { participantRequests.length > 0 &&
                <Button
                    variant="outlined"
                    color="primary"
                    style={{marginBottom: '10px'}}
                    onClick={() => setShowDialog(true)}
                >
                    Join Request ({participantRequests.length})
                </Button> }

                <Dialog id="dialog-main-container" open={showDialog}>
                    <DialogTitle>Participant Requests</DialogTitle>
                    <Divider />
                    <DialogContent>
                        <Box>
                            <List dense>
                                {participantRequests.map((participant) => (
                                    <RequestItem
                                        participant={participant}
                                        handleClose={async () => {
                                            await getAllParticipantRequests()
                                            updateParticipant()
                                        }}
                                    />
                                ))}
                            </List>
                        </Box>
                    </DialogContent>
                    <Divider />
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
        </>
    )
}

export default ParticipantRequest